<script setup lang="ts">
import { cn } from '@/lib/utils'
import { X } from 'lucide-vue-next'
import {
  DialogClose,
  DialogContent,
  type DialogContentEmits,
  type DialogContentProps,
  DialogOverlay,
  DialogPortal,
  useForwardPropsEmits,
} from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<DialogContentProps & { class?: HTMLAttributes['class'] }>()
const emits = defineEmits<DialogContentEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DialogPortal>
    <DialogOverlay
                   class="fixed inset-0 z-50 grid place-items-center overflow-y-auto bg-black/80 data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0">
      <DialogContent @interact-outside="(event) => {
        const target = event.target as HTMLElement;
        if (target?.closest('[data-sonner-toaster]')) return event.preventDefault();
      }"
                     :class="cn(
                      'relative z-50 grid w-full max-w-lg my-8 gap-4 border border-border bg-background p-1 sm:p-2 md:p-4 shadow-lg duration-200 sm:rounded-lg md:w-full',
                      props.class,
                    )
                      "
                     v-bind="forwarded"
                     @pointer-down-outside="(event) => {
                      const originalEvent = event.detail.originalEvent;
                      const target = originalEvent.target as HTMLElement;
                      if (originalEvent.offsetX > target.clientWidth || originalEvent.offsetY > target.clientHeight) {
                        event.preventDefault();
                      }
                    }">
        <div class="sticky top-0 z-50 -mb-8 flex justify-end pointer-events-none">
          <DialogClose
                       class="pointer-events-auto p-0.5 transition-colors rounded-md bg-background/80 hover:bg-secondary backdrop-blur-sm">
            <X class="w-8 h-8" />
            <span class="sr-only">Close</span>
          </DialogClose>
        </div>

        <slot />
      </DialogContent>
    </DialogOverlay>
  </DialogPortal>
</template>
